
customTranslateUrlLoader.$inject = ["$q", "$http"];var myapp = angular.module('FTIComply', ['FTIComply.login', 'ui.router',
    'ngMaterial',
    'datatables',
    'restangular',
    'ngMessages',
    'ngSanitize',
    'pascalprecht.translate',
    'FTIComply.languages.service',
    'FTIComply.translatableText.service',
]);
myapp.config(["$translateProvider", function ($translateProvider) {

    var base = angular.element(document.querySelector('#main')).data('project');

    $translateProvider.useMissingTranslationHandler('customTranslationHandler');
    $translateProvider.useLoader('customTranslateUrlLoader', {
        url: base + "/api/v1/login-angular-translation-entries",
        queryParameter: "languages_id"
    });
    $translateProvider.useSanitizeValueStrategy('escaped');
    //$translateProvider.useUrlLoader("api/v1/angular-translation-entries", {queryParameter: "languages_id"});

    $translateProvider.preferredLanguage('1');
    //$translateProvider.useLocalStorage();


}]);

myapp.config(["RestangularProvider", function (RestangularProvider) {
    var base = angular.element(document.querySelector('#main')).data('project');
    RestangularProvider.setBaseUrl(base + '/api/v1');
}]);

myapp.filter('translationSlugToID', ['translatableTextResource', function (translatableTextResource) {
    return function (slug) {
        return translatableTextResource.getTranslatableTextBySlug(slug);
    };
}]);

myapp.factory('customTranslationHandler', function () {
    return function (translationID, uses) {
        // return the following text as a translation 'result' - this will be
        // displayed instead of the language key.

        return 'Translation Not Found';
    };
});

myapp.factory('customTranslateUrlLoader', customTranslateUrlLoader);

function customTranslateUrlLoader($q, $http) {

    'use strict';

    return function (options) {

        if (!options || !options.url) {
            throw new Error('Couldn\'t use urlLoader since no url is given!');
        }

        var requestParams = {};

        requestParams[options.queryParameter || 'lang'] = options.key;

        return $http(angular.extend({
            url: options.url,
            params: requestParams,
            method: 'GET'
        }, options.$http))
            .then(function (result) {
                for (var key in result.data) {
                    if (result.data.hasOwnProperty(key)) {
                        if (  // result.data[key] === "" ||
                            result.data[key] === null) {
                            result.data[key] = "Translation Not Found";
                        }
                    }
                }
                return result.data;
            }, function () {
                return $q.reject(options.key);
            });
    };
}

angular.module('FTIComply.languages.service', [])

    .factory('languagesResource', ['Restangular', function (Restangular) {

        var service = {

            getLanguages: getLanguages
        };


        function getLanguages() {

            return Restangular.all('languages').getList();
        }


        return service;


    }]);

angular.module('FTIComply.translatableText.service', [])

    .factory('translatableTextResource', ['Restangular', function (Restangular) {

        var service = {
            register: {},
            loading: false,
            getTranslatableTextBySlug: getTranslatableTextBySlug,
            getTranslatedTextBySlug: getTranslatedTextBySlug
        };


        function getTranslatableTextBySlug(slugName) {

            if (service.register.hasOwnProperty(slugName)) {
                return service.register[slugName];
            } else {
                if (service.loading) {

                } else {
                    service.loading = true;
                    var promise = Restangular.one('translatable-text-by-slug', slugName).get().then(function (translatableTextResp) {
                        service.register[slugName] = translatableTextResp[0].id;
                        service.loading = false;
                    });
                }

                return "";
            }
        }

        function getTranslatedTextBySlug(slugName) {
            return Restangular.one('translatable-text-by-slug', slugName).get();
        }

        return service;


    }]);

angular.module('FTIComply.login', [])

    .controller('loginController', ['Restangular', '$scope', '$log', '$state', '$translate', 'languagesResource', '$timeout', '$location', '$http',
        function (Restangular, $scope, $log, $state, $translate, languagesResource, $timeout, $location, $http) {

            $scope.azureIntegrationSettingEnabled = false;
            $scope.oneLoginIntegrationSettingEnabled = false;
            $scope.auth0IntegrationSettingEnabled = false;
            $scope.adminLogin = true;

            // Initialize custom login alert properties
            $scope.customLoginAlertEnabled = false;
            $scope.customLoginAlertUrl = '';
            $scope.settingsLoaded = false;

            Restangular.all('client-settings').getList().then(function (settings) {

                $scope.clientSettings = settings;

                var auth0IntegrationSetting = _.find($scope.clientSettings, ['key', 'auth0_integration']);
                if (auth0IntegrationSetting) {
                    $scope.auth0IntegrationSettingEnabled = auth0IntegrationSetting.value == 1;
                }
                var oneLoginIntegrationSetting = _.find($scope.clientSettings, ['key', 'one_login_integration']);
                if (oneLoginIntegrationSetting) {
                    $scope.oneLoginIntegrationSettingEnabled = oneLoginIntegrationSetting.value == 1;
                }
                var azureIntegrationSetting = _.find($scope.clientSettings, ['key', 'azure_integration']);
                if (azureIntegrationSetting) {
                    $scope.azureIntegrationSettingEnabled = azureIntegrationSetting.value == 1;
                }

                // Custom login alert settings with setTimeout to prevent race condition
                var customLoginAlertEnabledSetting = _.find($scope.clientSettings, ['key', 'custom_login_alert_enabled']);
                var customLoginAlertUrlSetting = _.find($scope.clientSettings, ['key', 'custom_login_alert_url']);

                // Use setTimeout to ensure DOM is ready before showing the alert
                $timeout(function () {
                    if (customLoginAlertEnabledSetting) {
                        $scope.customLoginAlertEnabled = customLoginAlertEnabledSetting.value == 1;
                    }
                    if (customLoginAlertUrlSetting) {
                        $scope.customLoginAlertUrl = customLoginAlertUrlSetting.value;
                    } else {
                        $scope.customLoginAlertUrl = 'https://uat-igt-lottery.fticomply.com/auth/';
                    }
                    $scope.settingsLoaded = true;
                }, 100); // 100ms delay to ensure proper rendering

            }).catch(function (error) {
                // Handle error case and still set defaults after timeout
                $timeout(function () {
                    $scope.customLoginAlertUrl = 'https://uat-igt-lottery.fticomply.com/auth/';
                    $scope.settingsLoaded = true;
                }, 100);
            });

            $scope.samlUrl = 'auth-saml-login?redirectUrl=' + encodeURIComponent($location.absUrl());

            $scope.toggleAdminLogin = function () {
                $scope.adminLogin = !$scope.adminLogin;
            };

            languagesResource.getLanguages().then(function (languages) {
                $scope.languages = languages;
            });

            //console.log($scope);
            $scope.submitForm = function () {
                document.getElementById('loginForm').submit(function (event) {
                    event.preventDefault();
                }); //force to submit the form after clicking the button
            };

            // Set default as english language id.
            $scope.selectedLangID = ($scope.selectedLangID == undefined) ? 1 : $scope.selectedLangID;

            $scope.changeLanguage = function () {

                //langID = langID.toString();

                $translate.use($scope.selectedLangID);

                /* $timeout(function() {
                     // Do something
                 }, 1000).then(function() {
                     $window.location.reload();
                 });*/
            };


        }]);